import {  onChangeAuth, signUp } from "page/auth/redux"
import { useRedux } from "redux/useRedux"

import { Form } from "antd";
import { useNavigate } from "react-router-dom";
import { AuthContext } from 'contexts/auth-context';
import { useContext } from 'react';


const SignUpLogic = () => {
    const navigate = useNavigate()
    const [formSignUp] = Form.useForm()
    const ctx = useContext(AuthContext);
    const { dispatch, authState } = useRedux()
    async function finish() {
        let formData = new FormData();
        formData.append('username', formSignUp.getFieldsValue().username);
        // formData.append('first_name', formSignUp.getFieldsValue().first_name);
        // formData.append('last_name', formSignUp.getFieldsValue().last_name);
        // formData.append('password', formSignUp.getFieldsValue().password);
        const result = await dispatch(signUp(formData))
        if (result) {
            dispatch(onChangeAuth("time",60))
            dispatch(onChangeAuth("phone",formSignUp.getFieldsValue().username))
            dispatch(onChangeAuth("fromPage","login"))
            dispatch(onChangeAuth("status","otp"))
        }
    }
    return {
        formSignUp, finish
    }

}
export default SignUpLogic;